import { baseApi, Tag } from './base'
import { CreateInsAuditLogDto, InsAuditLog, InsOperation } from '@/core/models/ins-audit.model'

export const insAuditLogApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    logInsCall: builder.mutation<InsAuditLog, CreateInsAuditLogDto>({
      query: (body) => ({
        url: '/ins-audit-logs',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: Tag.INS_AUDIT_LOG, id: 'LIST' }],
    }),

    getInsAuditLogs: builder.query<
      { logs: InsAuditLog[]; total: number },
      { staff?: string; operation?: InsOperation; resultCode?: number; from?: string; to?: string; limit?: number; offset?: number; search?: string }
    >({
      query: ({ staff, operation, resultCode, from, to, limit, offset, search }) => ({
        url: '/admin/ins-audit-logs',
        params: {
          staff,
          operation,
          resultCode,
          from,
          to,
          limit,
          offset,
          search,
        },
      }),
      providesTags: [{ type: Tag.INS_AUDIT_LOG, id: 'LIST' }],
    }),

    getPatientInsAuditLogs: builder.query<
      { logs: InsAuditLog[]; total: number },
      { patientId: string; limit?: number; offset?: number }
    >({
      query: ({ patientId, limit, offset }) => ({
        url: `/patients/${patientId}/identity-audit-logs`,
        params: { limit, offset },
      }),
      providesTags: (_result, _error, { patientId }) => [
        { type: Tag.INS_AUDIT_LOG, id: patientId },
      ],
    }),
  }),
  overrideExisting: false,
})
